import React from "react";

// Cores padrão do sistema white label (devem ser iguais às do App.js)
const DEFAULT_PRIMARY_LIGHT = "#0000FF";   // Azul para tema claro
const DEFAULT_PRIMARY_DARK = "#065183";     // Azul corporativo para tema escuro (original do sistema)
const DEFAULT_SECONDARY_LIGHT = "#764ba2";  // Roxo para degradê tema claro
const DEFAULT_SECONDARY_DARK = "#0d47a1";   // Azul escuro para degradê tema escuro (harmoniza melhor)

const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
  setPrimaryColorLight: (_) => {},
  setPrimaryColorDark: (_) => {},
  setSecondaryColorLight: (_) => {},
  setSecondaryColorDark: (_) => {},
  setUseGradient: (_) => {},
  setAppLogoLight: (_) => {},
  setAppLogoDark: (_) => {},
  setAppLogoFavicon: (_) => {},
  setAppLogoBackgroundLight: (_) => {},
  setAppLogoBackgroundDark: (_) => {},
  // Valores atuais (defaults)
  primaryColorLight: DEFAULT_PRIMARY_LIGHT,
  primaryColorDark: DEFAULT_PRIMARY_DARK,
  secondaryColorLight: DEFAULT_SECONDARY_LIGHT,
  secondaryColorDark: DEFAULT_SECONDARY_DARK,
  useGradient: false,
});

export default ColorModeContext;
